export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9280.f7ab1373.jpg";